import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "col-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, "Dodatečné Info instalace:" + _toDisplayString(_ctx.installationInfo.appuuid), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " IČO ", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localData.ico) = $event)),
          type: "text",
          class: "form-control shadow-none rounded-0 text-black",
          placeholder: "IČO instalace"
        }, null, 512), [
          [_vModelText, _ctx.localData.ico]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Název subjektu ", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localData.subject_name) = $event)),
          type: "text",
          class: "form-control shadow-none rounded-0 text-black",
          placeholder: "Název instalace"
        }, null, 512), [
          [_vModelText, _ctx.localData.subject_name]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Poznámka ", -1)),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localData.note) = $event)),
            cols: "15",
            rows: "4",
            class: "input-post d-block w-100 text-black fs-14",
            placeholder: "Poznámka"
          }, null, 512), [
            [_vModelText, _ctx.localData.note]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, " Zpět "),
      _createElementVNode("button", {
        class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateInstallationInfo && _ctx.updateInstallationInfo(...args)))
      }, " Uložit ")
    ]),
    _createElementVNode("span", {
      class: _normalizeClass([_ctx.messageColorClass, "text-center"])
    }, _toDisplayString(_ctx.message), 3)
  ]))
}